import React, { Component } from 'react';

class TestInstanceTable extends Component {
    headers = [
        {
            key: 'name',
            name: 'Device name',
        },
        {
            key: 'model',
            name: 'Model',
        },
        {
            key: 'os',
            name: 'OS',
        },
        {
            key: 'osVersion',
            name: 'OS version',
        },
        {
            key: 'deviceType',
            name: 'Device type',
        },
        {
            key: 'status',
            name: 'Status',
            sortable: false,
        },
    ];

    render() {
        const { updateSort, sort, devices, arrow } = this.props;

        const headersDisplay = this.headers.map(({ key, name, sortable = true }) => (
            <th key={key} onClick={sortable ? () => updateSort(key) : null}>
                {name} {sort === key && sortable ? arrow : ''}
            </th>
        ));

        return (
            <div className="test-instance-overview-pagination block pull-right device-list-container">
              <div className="test-instance-devices-list-pagination">
                    <table className="table table-striped">
                        <thead>
                            <tr>{headersDisplay}</tr>
                        </thead>
                        <tbody>{devices}</tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default TestInstanceTable;
